var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3753 10.7286C20.3753 9.99646 20.3094 9.29588 20.1869 8.62219H10.7103V12.4818L16.1681 12.483C15.9467 13.7672 15.2343 14.862 14.1428 15.5918V18.0959H17.3915C19.2885 16.352 20.3753 13.7742 20.3753 10.7286Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1439 15.5918C13.2396 16.1977 12.075 16.5521 10.7126 16.5521C8.0809 16.5521 5.84834 14.7907 5.04882 12.4164H1.69763V14.9988C3.35792 18.2714 6.77033 20.517 10.7126 20.517C13.4374 20.517 15.7265 19.6269 17.3926 18.0947L14.1439 15.5918Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7332 10.5006C4.7332 9.8339 4.84506 9.18946 5.04877 8.58362V6.00116H1.69759C1.0111 7.35437 0.624878 8.88186 0.624878 10.5006C0.624878 12.1193 1.01228 13.6468 1.69759 15L5.04877 12.4175C4.84506 11.8117 4.7332 11.1672 4.7332 10.5006Z",
    fill: "#FABB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7126 4.44794C12.1998 4.44794 13.5316 4.95671 14.5831 5.95086L17.4621 3.09356C15.7135 1.47601 13.4338 0.483032 10.7126 0.483032C6.77151 0.483032 3.35792 2.72864 1.69763 6.00115L5.04882 8.58361C5.84834 6.20934 8.0809 4.44794 10.7126 4.44794Z",
    fill: "#E94235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.b613bf613195a1a455a0c3da5025c14d.svg";
export { ForwardRef as ReactComponent };